import React, { useState } from "react";
import "./roommodaldetails.css";
import { amenityIcons, defaultIcon } from "./amenityIcons";
import { PiArrowCircleUpRightFill } from "react-icons/pi";
import { Carousel } from "react-bootstrap";
import noImg from "../../../assets/images/image_placeholder.jpg";
import moment from "moment";
import SwiperThumb from "./SwiperThumb";

export default function RoomModalDetails(data, termsData) {
  // console.log('data::: ', data);
  const headerImg = [
    "https://images.pexels.com/photos/1669799/pexels-photo-1669799.jpeg",
    "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg",
    "https://plus.unsplash.com/premium_photo-1676823547752-1d24e8597047?fm=jpg",
  ];

  const tabsData = [
    { label: "Room Photos", content: <p>Content for Tab 1</p> },
    { label: "Room Details", content: <p>Content for Tab 1</p> },
    { label: "Map", content: <p>Content for Tab 2</p> },
    { label: "Terms & Conditions", content: <p>Content for Tab 2</p> },
  ];

  const [activeTab, setActiveTab] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleTabClick = (index) => {
    if (index !== activeTab) {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveTab(index);
        setIsAnimating(false);
      }, 300); // Duration of the animation in ms
    }
  };

  const images = data?.data?.gallery?.map(item => item.attachment) || [];

  const groupedAmenities = Array.isArray(data?.data?.amenities)
    ? data?.data?.amenities.reduce((acc, item) => {
        if (typeof item === "string") {
          // Handle first format (array of strings)
          const category = "General Amenities";
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push({ name: item, code: item });
        } else if (typeof item === "object" && item.name) {
          // Handle second format (array of objects)
          const category = item.category || "Other";
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(item);
        }
        return acc;
      }, {})
    : {};

  return (
    <div>
      <div className="tabs-container">
        <div className="tabs-header">
          {tabsData.map((tab, index) => (
            <button
              key={index}
              className={`tab-button ${activeTab === index ? "active" : ""}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div
          className={`tabs-content ${isAnimating ? "fade-out" : "fade-in"}`}
          key={activeTab}
        >
          {tabsData[activeTab] && (() => {
            const activeLabel = tabsData[activeTab].label;

            if (activeLabel === "Room Details") {
              return (
                <div>

                  <div className="room_title_modal_amenities mt-3">
                    {data?.data?.description && (
                      <>
                        <h6>Room description</h6>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: data?.data?.description,
                          }}
                        />
                      </>
                    )}
                    <h6>Room facilities</h6>
                    <div className="room-amenities-container">
                      <div className="amenities-grid-box">
                        {Object.keys(groupedAmenities)?.map((category, categoryIndex) => (
                          <div key={categoryIndex} className="amenity-category">
                            <h6>{category}</h6>
                            <div className="amenities-wrapper">
                              {groupedAmenities[category]?.map((item, index) => {
                                const amenityName = item.name || item.code || "-";
                                const iconSrc = amenityIcons[amenityName] || defaultIcon;
                                return (
                                  <div className="amenity-card-box" key={index}>
                                    <div className="amenity-icon">{iconSrc}</div>
                                    <div className="amenity-details">
                                      <span className="amenity-label">{amenityName}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* <h6 className="mt-3">Hotel rules</h6>
                    <div className="house-rules">
                      <div className="d-flex align-content-center gap-5">
                        <div className="rule-section">
                          <h6>Check-in</h6>
                          <p>
                            {moment(data?.data?.checkInDate).format("DD-MM-YYYY")}{" "}
                            &nbsp;( From 12:00 PM )
                          </p>
                        </div>

                        <div className="rule-section">
                          <h6>Check-out</h6>
                          <p>
                            {moment(data?.data?.checkOutDate).format("DD-MM-YYYY")}{" "}
                            &nbsp;( Until 11:00 AM )
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              );
            } else if (activeLabel === "Terms & Conditions") {
              return (
                <div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: data?.termsData?.doctemplate,
                    }}
                  ></p>
                </div>
              );
            } else if (activeLabel === "Enquiry") {
              return (
                <div className="enquiry-container">
                  <h6>Enquiry</h6>
                  <form>
                    <div>
                      <label htmlFor="name">Name:</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                      />
                    </div>
                    <div>
                      <label htmlFor="email">Email:</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </div>
                    <div>
                      <label htmlFor="message">Message:</label>
                      <textarea
                        id="message"
                        name="message"
                        placeholder="Write your message here"
                      ></textarea>
                    </div>
                    <button type="submit">Submit</button>
                  </form>
                </div>
              );
            } else if (activeLabel === "Map") {
              return (
                <div>
                  <div style={{ width: "100%", height: "450px" }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3072.988929658085!2d-106.05352492432158!3d39.62745310329952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876a5b992a739c1b%3A0x23070399c7fc8d6e!2sSpinnaker%20Lake%20Dillon!5e0!3m2!1sen!2sin!4v1746130491184!5m2!1sen!2sin"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Spinnaker Lake Dillon Map"
                    ></iframe>
                  </div>
                </div>
              );
            } else if (activeLabel === "Room Photos") {
              return (
                <div>
                  {data?.data && data?.data?.gallery?.length > 0 ? (
                    <SwiperThumb
                      objectFit={true}
                      height={400}
                      value={7}
                      roomImgs={images}
                    />
                  ) : (
                    <div className="carousel_img_container">
                      <img
                        style={{ width: "100%", height: "100%" }}
                        alt="carouselImg"
                        loading="lazy"
                        src={noImg}
                      />
                    </div>
                  )}
                </div>
              );
            }
            else {
              return (
                <div>
                  <p>No content available for this tab.</p>
                </div>
              );
            }
          })()}
        </div>
      </div>
    </div>
  );
}
